import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import '@fontsource/poppins'
import { ThemeProvider as MaterialThemeProvider } from '@mui/material'
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react'
import { theme } from 'theme'
import { getChainOptions, WalletProvider } from '@terra-money/wallet-provider'
import { ModalProvider } from 'react-modal-hook'
import { BrowserRouter as Router } from 'react-router-dom'

getChainOptions().then((chainOptions) => {
  ReactDOM.render(
    <MaterialThemeProvider theme={theme}>
      <EmotionThemeProvider theme={theme}>
        <WalletProvider {...chainOptions}>
          <Router>
            <ModalProvider>
              <App />
            </ModalProvider>
          </Router>
        </WalletProvider>
      </EmotionThemeProvider>
    </MaterialThemeProvider>,

    document.getElementById('root'),
  )
})
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
